import {React, useState, useRef} from 'react';

import constants from "../../../constants.js"
import styles from './selecttable.module.css'


const SelectTable = ({headers, tableKey, tableData, 
  selectRow, selectColumnHeader, tableTitle, titleColor, canSelect, 
  showSwapButton, onSwapButtonClicked, isSwapping, swappingPlayer, replacePlayer, removePlayer, isLineupLocked, 
  matchupTime, matchupEnded}) => {

  const handleChange = (e, row) => {
    selectRow(e, row);
  } 

  const isBeforeMatchTime = () => {
    // Z for true UTC conversion
    return new Date() < new Date(matchupTime + 'Z');
  };

  const getSwapButton = (player) => {

    if (isSwapping) {
      if (player[constants.playerId] == swappingPlayer[constants.playerId]) {
        return (
          <button className={styles.RemoveButton} onClick={() => removePlayer(player[constants.playerId])}>Remove</button>
        )
      }
      else if (!player.selected && player[constants.gender] === swappingPlayer[constants.gender] && isBeforeMatchTime(matchupTime)) {
        return(
          <button className={styles.ReplaceButton} onClick={() => replacePlayer(player[constants.playerId])}>Replace</button>
        )
      }
    } 
    else {
      return (
        player.selected ? <button className={styles.SwapButton} onClick={() => onSwapButtonClicked(player)}>Swap</button> : <></>
      )
    }
  }

  return (
    <div className={styles.TableContainer}>
      <table className={styles.Table}>
        {tableTitle && 
        <caption 
          className={styles.TableTitle} 
          style={{background:`${titleColor ? titleColor : constants.colors.cplGray}`}}>
            <div className={styles.TitleText}>{tableTitle}</div>
        </caption>}
        <thead className={styles.HeaderRow}>
          <tr>
            {canSelect ? <th
              className={`${styles.Header} ${styles.StickyHeader}`}
              style={{width:'5%', textAlign:'center', fontWeight:'500'}}
              id={"checkColumn"} 
              key={"checkColumn"}>
                {selectColumnHeader ? selectColumnHeader : ""}
            </th> : <></>}
            {showSwapButton ? <th
              className={`${styles.Header} ${styles.StickyHeader}`}
              style={{width:'5%', textAlign:'center', fontWeight:'500'}}
              id={"buttonColumn"} 
              key={"buttonColumn"}>
                {""}
            </th> : <></>}
            {headers.map((header, i) => {
              return (
                <th
                className={`${styles.Header} ${i==0 ? styles.StickyHeader : ""}`}
                style={{width: header.width, textAlign: header.text, fontWeight: "bold"}} 
                id={header.value} 
                key={header.value}>
                  {header.label}
                </th>
              )
            })}
          </tr>
        </thead>

        <tbody className={styles.Body}>
          {tableData.map((element, i) => {
            {/* Alternate color for every other row*/}
            const background = i%2 == 1 ? constants.colors.cplWhite : constants.colors.cplGray

            return (<tr style={{backgroundColor: background}} key={element[tableKey]}>
              {canSelect ? <td className={styles.Cell} style={{width: '5em', textAlign:'center'}}>
                <input 
                  type="checkbox"
                  disabled={element.disabled}
                  checked={element.selected}
                  onChange={(e) => handleChange(e, element)} />
              </td> : <></>}
              {showSwapButton ? <td className={styles.Cell}>
                {matchupEnded ? <></> : getSwapButton(element)}
              </td> : <></>}
              {headers.map((item, j) => {
                return (
                  <td id={element[item[constants.playerId]]} className={styles.Cell} style={{textAlign:item.text}} key={`${element[tableKey]}-${item.value}`}>
                    {element[item.value]} {isSwapping && item.value === "name" && swappingPlayer[constants.playerId]===element[constants.playerId] ? <button className={styles.SwappingButton}>Swapping</button> : <></>}
                  </td>
                )
              })}
              {isSwapping && swappingPlayer===element[constants.playerId] ? 
                <td className={styles.Cell}>
                  
                </td> : <></>}
            </tr>)
          })}
        </tbody>
      </table>
    </div>
  )
}

export default SelectTable;